import React from 'react';
import PropTypes from 'prop-types';
// import { Banner } from './Banner';
import { Navbar } from './Navbar';

export const Header = ({ history }) => (
  <Navbar history={history} />
);

Header.propTypes = {
  history: PropTypes.shape({}).isRequired,
};
